import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IFormFieldSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { InputProps } from 'antd';

export const generate = (
  props?: Partial<IFormFieldSchema<InputProps>>
): IFormFieldSchema<InputProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.STRING,
    name: props?.name || id,
    title: props?.title || 'Password',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-decorator': 'FormItem',
    'x-component': ComponentType.FormInputPassword,
    'x-validator': [],
    'x-component-props': {},
    'x-component-props-config': {},
    'x-decorator-props': {},
    'x-decorator-props-config': {},
  };
};
